import React from 'react';
import { useStores } from '../hooks/use-stores';
import { useEffect } from 'react';
import { observer } from 'mobx-react';

const Header = observer(() => {
    const { HeaderStore: store } = useStores();

    useEffect(() => {
        document.title = store.title;
    }, [store, store.title]);

    if (!store.show) {
        return null;
    }

    return (
        <div className="section red ornament">
            <div id="header" className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="wrapper">
                            <h1>{store.title}</h1>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
});

export default Header;

export const H4 = props => (
    <div className="default-title-block mb-25" {...props}>
        {props.children}
    </div>
);
